import { Navigate, useLocation } from 'react-router-dom';
import { useAuthQuery } from 'hooks/queries/useAuthQuery';
import { UserPermission } from 'models/userPermission';
import { message } from 'antd';
import { intl } from 'services/intl';
import { authService } from 'pages/auth/authService';
import { useUserPermissionsQuery } from 'hooks/queries/useUserPermissionsQuery';
import { Loader } from 'pages/dashboard/components/Loader';

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const { data, isLoading } = useAuthQuery();
  const location = useLocation();
  const permissions = useUserPermissionsQuery();

  if (isLoading) {
    return <Loader fullScreen={true} />;
  }

  if (!data) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (
    !permissions?.some((x) =>
      [UserPermission.GlobalAdmin, UserPermission.GymAdmin].includes(x)
    )
  ) {
    message.error({
      content: intl.formatMessage({ id: 'error.accessDenied' }),
      key: 'access-denied',
    });
    authService.logout();
  }

  return children;
};
